<template>
  <section>
    <div class="home-heading">
      <p class="brand-story" data-aos="fade-left">BRAND<br />STORY</p>
      <p class="sushishogun-h" data-aos="fade-right">
        SUSHI<br />
        SHOGUN
      </p>
      <div class="ppp" data-aos="fade-up">
        <p class="p1">
          Honestly saying this is not a place that feels like home, rather a
          place where you feel like you belong. Our Vision is clear, we are not
          just a restaurant, it’s an adventure that's like a song you want to
          put on a constant replay. We don’t like to play with words, we love to
          play on flavors.
        </p>
        <p class="p2">
          By undertaking the delicate flavor and the ingenuity of Japanese
          cuisine, we made it sing with the collaboration of modern cooking
          techniques and sophisticated local cuisine. With access to beautiful
          local and other delicate ingredients, we adapt and innovate constantly
          to create sparks in our dishes and your experience.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.ppp {
  margin: auto;
}
.p1 {
  width: 50%;
  height: auto;
  margin: auto;
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding-top: 5%;
  text-align: center;
  letter-spacing: 0.02em;

  /* white */

  color: #ffffff;
}

.p2 {
  width: 50%;
  height: auto;
  margin: auto;
  padding-top: 20px;
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  text-align: center;
  letter-spacing: 0.02em;
  /* white */

  color: #ffffff;
}

.home-heading {
  height: 100vh;
  background: black;
  font-size: 36px;
  padding: 5% 0 10% 0;
}
.brand-story {
  position: relative;
  width: 12%;
  height: auto;
  left: 50%;

  font-family: avenirLight;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 24px;
  /* or 100% */

  letter-spacing: 0.2em;
  text-transform: uppercase;

  color: #c7272b;
}
.sushishogun-h {
  position: relative;
  width: 18%;
  left: 32%;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 2.75rem;
  line-height: 50px;
  /* or 109% */

  text-align: right;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
@media only screen and (max-width:639px)
{
  .home-heading {
  height: 80vh;
  }
    .brand-story, .p2, .p1
    {
        width:80%;
        left:0;
        text-align:center;
        margin:auto;
    } 
  
    .sushishogun-h
    {
         width:80%;
         left:0;
        text-align:center;
        margin:auto;
        font-size:2rem;
    }
.home-heading br, .sushishogun-h br
{
    display:none;
}
}

</style>